import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import clarity from '@microsoft/clarity';

@Injectable({
  providedIn: 'root'
})
export class ClarityService {

  constructor() { }

  /**
   * Inicializa Microsoft Clarity.
   * - En plataformas nativas (iOS/Android): los SDKs nativos se inicializan
   *   en MainActivity.java / AppDelegate.swift. No se necesita el SDK web.
   * - En web/PWA: se usa el SDK web @microsoft/clarity.
   */
  init() {
    try {
      const platform = Capacitor.getPlatform();
      const isNative = Capacitor.isNativePlatform();

      if (isNative) {
        // Los SDKs nativos de Clarity se inicializan directamente en el código nativo
        // (MainActivity.java para Android, AppDelegate.swift para iOS).
        // No es necesario inicializar el SDK web en plataformas nativas.
        console.log(`✅ [Clarity] Native SDK handles initialization on ${platform}`);
        return;
      }

      // Solo inicializar el SDK web para compilaciones web/PWA
      const PROJECT_ID = 'vjg3cpbydl';
      clarity.init(PROJECT_ID);
      clarity.setTag('platform', platform);
      clarity.setTag('is_native', 'false');
      
      console.log(`✅ [Clarity] Web SDK initialized successfully on ${platform}`);
    } catch (error) {
      console.error('❌ [Clarity] Failed to initialize:', error);
    }
  }

  /**
   * Úsalo después del login para identificar a tus usuarios
   * @param userId ID único del usuario en tu base de datos
   * @param properties Propiedades adicionales del usuario
   */
  identifyUser(userId: string, properties?: any) {
    try {
      clarity.identify(userId, properties);
      console.log(`✅ [Clarity] User identified: ${userId}`);
    } catch (error) {
      console.error('❌ [Clarity] Failed to identify user:', error);
    }
  }
}